import { Theme, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { get as _get } from 'lodash';
import { ProviderInfo } from '../../../types/type';
import ServiceCompanyInfo from '../ServiceCompanyInfo/ServiceCompanyInfo';
export interface ProviderInfoCollectionType {
  providers: ProviderInfo[];
  checkedValue?: string;
  providerListItemClickHandler: (providerID: string) => void | undefined;
}

export default function ServiceCard(props: ProviderInfoCollectionType) {
  const theme: Theme = useTheme();
  return (
    <Box sx={{ width: '100%' }}>
      {props.providers &&
        props.providers.map((provider: ProviderInfo) => (
          <Box key={provider.providerID} sx={{ minWidth: 275, padding: '.5rem' }}>
            <Card
              onClick={(event) => {
                props.providerListItemClickHandler(_get(provider, 'providerID', ''));
              }}
              variant="outlined"
              sx={{
                borderColor:
                  props.checkedValue === provider.providerID
                    ? theme.custom.styles.serviceProviderSelectedCardStyle
                    : theme.custom.styles.serviceProviderCardStyle,
              }}
            >
              <CardContent>
                <ServiceCompanyInfo
                  isRadioButtonEnabled={true}
                  provider={provider}
                  checkedValue={props.checkedValue}
                  providerListItemClickHandler={props.providerListItemClickHandler}
                ></ServiceCompanyInfo>
              </CardContent>
            </Card>
            {!theme.custom.styles.showBorderAroundListItems && (
              <hr
                style={{
                  border: theme.custom.styles.serviceProviderCardHr,
                  width: '100%',
                }}
              ></hr>
            )}
          </Box>
        ))}
    </Box>
  );
}
